module.exports = __webpack_public_path__ + "static/media/recruit_230_business.db91f18e.png";